import React from 'react';
import { Link } from 'react-router-dom';
// import { useMenuData } from './useMenuData'; // Adjust path

function Offcanvas({ isOpen, toggleOffcanvas }) {


  return (
    <>
      <div className={`fix-area ${isOpen ? 'active' : ''}`}>
        <div className="offcanvas__info">
          <div className="offcanvas__wrapper">
            <div className="offcanvas__content">
              <div className="offcanvas__top mb-5 d-flex justify-content-between align-items-center">
                <div className="offcanvas__logo">
                  <Link to="/">
                    <img src="./assets/img/logo/fayah-logo.png" alt="logo-img"
                    style={{ height: '100px', objectFit: 'contain' }} />
                  </Link>
                </div>
                <div className="offcanvas__close">
                  <button onClick={toggleOffcanvas}>
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <p className="text d-none d-xl-block">
                Welcome to our travel agency! Explore the world with us and discover amazing destinations, exclusive tours, and unforgettable experiences. Whether you're looking for adventure, relaxation, or cultural immersion, we have the perfect package for you. Let's make your travel dreams come true!
              </p>
              <div className="mobile-menu fix mb-3"></div>
              <div className="offcanvas__contact">
                <h4>Contact Info</h4>
                <ul>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon">
                      <i className="fal fa-map-marker-alt"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                      <a target="_blank" href="/contact-us">Lamka Court, Katani Rd, Syokimau</a>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="fal fa-envelope"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                      <a href="mailto:info@fayahtravels.com"><span class="mailto:info@fayahtravels.com">info@fayahtravels.com</span></a>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="fal fa-clock"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                      <a target="_blank" href="/contact-us">Mon-friday, 09am -05pm</a>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="far fa-phone"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                      <a href="tel:254742940940">+254742940940</a>
                    </div>
                  </li>
                </ul>
                <div className="header-button mt-4">
                  <Link to="/contact-us" className="theme-btn">
                    Request A Quote <i className="fa-sharp fa-regular fa-arrow-right"></i>
                  </Link>
                </div>
                <div className="social-icon d-flex align-items-center">
                  <Link to="#"><i className="fab fa-facebook-f"></i></Link>
                  <Link to="#"><i className="fab fa-twitter"></i></Link>
                  <Link to="#"><i className="fab fa-youtube"></i></Link>
                  <Link to="#"><i className="fab fa-linkedin-in"></i></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`offcanvas__overlay ${isOpen ? 'active' : ''}`} onClick={toggleOffcanvas}></div>
    </>
  );
}

export default Offcanvas;